var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIonic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128.152 0.0011856C148.929 0.0011856 168.493 4.85546 186.844 14.2583L189.27 15.4716L187.147 17.1398C181.991 21.2346 177.896 26.5427 175.318 32.609L174.559 34.2773L173.043 33.519C158.938 26.846 143.924 23.3578 128.303 23.3578C70.5213 23.3578 23.6588 70.372 23.6588 128.002C23.6588 185.633 70.3697 232.647 128.152 232.647C185.934 232.647 232.796 185.633 232.796 128.002C232.796 114.201 230.218 100.704 224.758 87.9645L224 86.2962L225.668 85.5379C231.886 83.263 237.346 79.4716 241.744 74.6185L243.412 72.4953L244.474 74.9218C252.209 91.7559 256 109.652 256 127.699C256 198.22 198.521 255.699 128 255.699C57.4787 255.699 0 198.22 0 127.699C0 57.1777 57.4787 -0.300937 128.152 0.0011856ZM128.152 69.7654C160.152 69.7654 186.389 95.8507 186.54 128.154C186.54 160.457 160.455 186.543 128.152 186.543C95.8483 186.543 69.763 160.457 69.763 128.154C69.763 95.8507 96 69.7654 128.152 69.7654ZM211.716 21.5379C226.457 21.5379 238.408 33.4883 238.408 48.2299C238.408 62.9714 226.457 74.9218 211.716 74.9218C196.974 74.9218 185.024 62.9714 185.024 48.2299C185.024 33.4883 196.974 21.5379 211.716 21.5379Z",
    fill: "#3880FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIonic);
export default __webpack_public_path__ + "static/media/ionic.711c6d3d08781588409d628a2458de65.svg";
export { ForwardRef as ReactComponent };